import { Box, Stack, ToggleButton } from '@mui/material'
import * as Icons from '@mui/icons-material'
import { TpToggleButtonGroup } from '~/components'
import { TpControlTooltip } from '~/components/tp-control-tooltip'

const REFERENCE_COLORS = [
  '#e57373', '#f48fb1', '#ce93d8', '#b39ddb', '#80cbc4', '#4db6ac',
  '#a5d6a7', '#81c784', '#e6ee9c', '#fff176', '#ffe082', '#ffcc80',
  '#ff8a65', '#bcaaa4', '#a1887f', '#90a4ae', '#ba68c8', '#f06292',
  '#dce775', '#ffd54f',
]

export const DrawControls = ({ points, onUndo, onClear, showCartesian, onToggleCartesian, referenceColor, onColorChange }) => {
  const hasPoints = points.length > 0
  const showColorPicker = referenceColor !== undefined && onColorChange !== undefined

  return (
    <Stack
      direction='column'
      spacing={0.75}
      sx={{
        position: 'absolute',
        bottom: 8,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        alignItems: 'center',
      }}
    >
      {showColorPicker && (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.45)',
            borderRadius: '8px',
            padding: '6px 8px',
            maxWidth: '220px',
          }}
        >
          {REFERENCE_COLORS.map(color => (
            <Box
              key={color}
              onClick={() => onColorChange(color)}
              sx={{
                width: 18,
                height: 18,
                borderRadius: '50%',
                backgroundColor: color,
                cursor: 'pointer',
                border: referenceColor === color ? '2px solid #fff' : '2px solid transparent',
                boxShadow: referenceColor === color ? `0 0 0 1px ${color}` : 'none',
                flexShrink: 0,
              }}
            />
          ))}
        </Box>
      )}

      <Stack direction='row' spacing={1}>
        <TpControlTooltip title="Undo / Clear">
          <TpToggleButtonGroup>
            <ToggleButton value="undo" disabled={!hasPoints} onClick={onUndo}>
              <Icons.Undo fontSize='small' />
            </ToggleButton>
            <ToggleButton
              value="clear"
              disabled={!hasPoints}
              onClick={onClear}
              sx={{ '&:not(.Mui-disabled)': { color: 'error.main' } }}
            >
              <Icons.Delete fontSize='small' />
            </ToggleButton>
          </TpToggleButtonGroup>
        </TpControlTooltip>

        <TpControlTooltip title="Distance guide lines">
          <TpToggleButtonGroup
            exclusive
            value={showCartesian ? 'cartesian' : null}
            onChange={onToggleCartesian}
          >
            <ToggleButton value="cartesian">
              <Icons.GridOn fontSize='small' />
            </ToggleButton>
          </TpToggleButtonGroup>
        </TpControlTooltip>
      </Stack>
    </Stack>
  )
}
